import db, { parseFirestoreDoc } from '@helpers/firebase/Firestore';
import { Group } from '@types';

export function parseGroupDoc(doc: db.DocumentSnapshot) {
  return parseFirestoreDoc<Group>(doc, 'groupId');
}
